let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("c6MKV"), load("aZinD"), load("f8xBv"), load("9lDKI")]).then(() => parcelRequire('68LQc'));